import { apiService, type HpRequestPostPut } from '../service'

const url = 'assfinet'

export const assfinetService = {
	damageReportCreate: (
		data: HpRequestPostPut<Api.AssfinetDamageReportPostInput>
	) => apiService.post({ url: `${url}/damage_reports`, ...data }),
}

export default assfinetService
